<template>
  <div class="ai-criteria">
    <el-form label-width="125px" size="small">
      <el-form-item label="产品类别">
        <el-select :value="value.category" clearable :placeholder="categoryOptional?'不限，由各方案确认':'需确认类别'" @change="set('category', $event)">
          <el-option label="普通配方" value="普通配方"/><el-option label="特配" value="特配"/>
        </el-select>
      </el-form-item>
      <el-form-item label="备选标签">
        <el-select :value="value.any_tags" multiple filterable placeholder="任一命中即可，按选择先后排序" @change="set('any_tags', $event)" class="wide">
          <el-option v-for="d in tags" :key="d.id" :label="label(d)" :value="d.id"/>
        </el-select>
        <div class="hint">标签和数值参数分别核对。若同时设置标签与参数，产品必须分别满足，不会因填写数值而自动获得标签。</div>
        <div v-for="(id, i) in value.any_tags" :key="id" class="priority-row">
          <span>{{ i + 1 }}. {{ name(id) }}</span>
          <el-button type="text" :disabled="i===0" @click="move('any_tags', i, -1)">上移</el-button>
          <el-button type="text" :disabled="i===value.any_tags.length-1" @click="move('any_tags', i, 1)">下移</el-button>
        </div>
      </el-form-item>
      <el-form-item label="必须标签">
        <el-select :value="value.must_tags" multiple filterable class="wide" @change="set('must_tags', $event)">
          <el-option v-for="d in tags" :key="d.id" :label="label(d)" :value="d.id"/>
        </el-select>
      </el-form-item>
      <el-form-item label="排除标签">
        <el-select :value="value.exclude_tags" multiple filterable class="wide" @change="set('exclude_tags', $event)">
          <el-option v-for="d in tags" :key="d.id" :label="label(d)" :value="d.id"/>
        </el-select>
        <div class="hint">敏感成分请在参数条件中选择“等于 无”；未录入不能作为“不含”的依据。</div>
      </el-form-item>
      <el-form-item label="必要参数条件">
        <div v-for="(r,i) in value.requirements" :key="i" class="condition-row">
          <el-select :value="r.parameter_id" filterable placeholder="参数" @change="patch('requirements',i,{parameter_id:$event,value:'',operator:'eq'})">
            <el-option v-for="d in parameters" :key="d.id" :value="d.id" :label="label(d)"/>
          </el-select>
          <el-select :value="r.operator" class="operator" @change="patch('requirements',i,{operator:$event})">
            <el-option v-for="op in operators(r.parameter_id)" :key="op.value" :value="op.value" :label="op.label"/>
          </el-select>
          <el-select v-if="definition(r.parameter_id).kind === 'boolean'" :value="r.value" class="value" @change="patch('requirements',i,{value:$event})">
            <el-option label="有" value="true"/><el-option label="无" value="false"/>
          </el-select>
          <el-input v-else :value="r.value" class="value" placeholder="值" @input="patch('requirements',i,{value:$event})"/>
          <span class="unit">{{ definition(r.parameter_id).unit }}</span>
          <el-button type="text" @click="remove('requirements',i)">移除</el-button>
        </div>
        <el-button :disabled="value.requirements.length>=30" @click="add('requirements',{parameter_id:'',operator:'eq',value:''})">添加参数条件</el-button>
      </el-form-item>
      <el-form-item label="组内数值排序">
        <div v-for="(s,i) in value.sort" :key="i" class="condition-row">
          <span>{{ i+1 }}</span>
          <el-select :value="s.parameter_id" filterable placeholder="排序参数" @change="patch('sort',i,{parameter_id:$event,direction:definition($event).direction || ''})">
            <el-option v-for="d in numbers" :key="d.id" :value="d.id" :label="label(d)"/>
          </el-select>
          <el-select :value="s.direction" class="operator" placeholder="确认方向" @change="patch('sort',i,{direction:$event})">
            <el-option label="从高到低" value="desc"/><el-option label="从低到高" value="asc"/>
          </el-select>
          <el-button type="text" :disabled="i===0" @click="move('sort',i,-1)">上移</el-button>
          <el-button type="text" @click="remove('sort',i)">移除</el-button>
        </div>
        <el-button :disabled="value.sort.length>=10" @click="add('sort',{parameter_id:'',direction:''})">添加排序项</el-button>
        <div class="hint">符合条件的优先星标先顶置，再按标签优先级及以上数值逐项比较；未知值排在已知值后。兜底星标仅在无匹配时作为备选。</div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { clone } from './ai-api';
export default {
  props: { value: { type: Object, required: true }, definitions: { type: Array, default: () => [] }, categoryOptional: { type: Boolean, default: false } },
  computed: {
    tags() { return this.definitions.filter(d => d.kind === 'tag'); },
    parameters() { return this.definitions.filter(d => d.kind !== 'tag'); },
    numbers() { return this.definitions.filter(d => d.kind === 'number'); }
  },
  methods: {
    definition(id) { return this.definitions.find(d => d.id === id) || {}; },
    name(id) { return this.definition(id).name || '已失效的标签'; },
    label(d) { return d.name + (d.active ? '' : '（未启用）'); },
    set(key, v) { this.$emit('input', { ...this.value, [key]: v }); },
    add(key, v) { this.set(key, [...this.value[key], v]); },
    remove(key, i) { const a = clone(this.value[key]); a.splice(i,1); this.set(key,a); },
    patch(key, i, v) { const a = clone(this.value[key]); a[i] = { ...a[i], ...v }; this.set(key,a); },
    move(key, i, by) { const a = clone(this.value[key]); const item=a.splice(i,1)[0]; a.splice(i+by,0,item); this.set(key,a); },
    operators(id) {
      const ops=[{value:'eq',label:'等于'},{value:'ne',label:'不等于'}];
      return this.definition(id).kind === 'number' ? [...ops,{value:'gte',label:'大于等于'},{value:'lte',label:'小于等于'},{value:'gt',label:'大于'},{value:'lt',label:'小于'}] : ops;
    }
  }
};
</script>
<style scoped>
.wide { width:100%; max-width:680px; }
.condition-row { display:flex; gap:8px; align-items:center; flex-wrap:wrap; margin-bottom:10px; }
.condition-row .el-select { width:230px; }
.condition-row .operator { width:125px; }
.condition-row .value { width:135px; }
.priority-row { display:flex; gap:12px; align-items:center; line-height:28px; }
.priority-row span { min-width:220px; }
.hint { font-size:12px; color:#767676; line-height:1.6; margin-top:6px; }
.unit { color:#666; }
</style>
